import { useCallback, useState } from 'react';
import { ResourceHistoryChangeCategory } from '@dispatch/shared/types';

const ALL_CATEGORIES: ResourceHistoryChangeCategory[] = [
  'Resource',
  'Schedule',
  'Event',
];

export interface ResourceHistoryFilterState {
  selectedCategories: ResourceHistoryChangeCategory[];
  toggleCategory: (category: ResourceHistoryChangeCategory) => void;
  /** Show `user`-actor (UI-initiated) rows. */
  showUiChanges: boolean;
  setShowUiChanges: (value: boolean) => void;
  /** Show `system`-actor (API/integration) rows. */
  showApiChanges: boolean;
  setShowApiChanges: (value: boolean) => void;
}

/**
 * Client-side view state for the Resource History tab. Per the ticket AC,
 * API (System-actor) changes are hidden by default so routine sync changes
 * don't bury human edits; UI (user-actor) changes show by default. All change
 * categories start selected. Bulk-actor rows are always visible and are not
 * governed by these toggles.
 */
export function useResourceHistoryFilters(): ResourceHistoryFilterState {
  const [selectedCategories, setSelectedCategories] = useState<
    ResourceHistoryChangeCategory[]
  >([...ALL_CATEGORIES]);
  const [showUiChanges, setShowUiChanges] = useState(true);
  const [showApiChanges, setShowApiChanges] = useState(false);

  const toggleCategory = useCallback(
    (category: ResourceHistoryChangeCategory) => {
      setSelectedCategories((current) =>
        current.includes(category)
          ? current.filter((item) => item !== category)
          : [...current, category]
      );
    },
    []
  );

  return {
    selectedCategories,
    toggleCategory,
    showUiChanges,
    setShowUiChanges,
    showApiChanges,
    setShowApiChanges,
  };
}
